/**
 * 慢病绪方相关路由
 */
export default [
  /**
   * 选择医院
   */
  {
    path: '/renewal/index',
    meta: {
      title: '慢病续方'
    },
    component: () => import('../pages/renewal/index')
  },
  /**
   * 选择患者
   */
  {
    path: '/renewal/choose',
    meta: {
      title: '申请续方'
    },
    component: () => import('../pages/renewal/choose')
  },
  /**
   * 历史处方
   */
  {
    path: '/renewal/history',
    meta: {
      title: '慢病续方'
    },
    component: () => import('../pages/renewal/history')
  },
  /**
   * 外院处方
   */
  {
    path: '/renewal/waiyuan',
    meta: {
      title: '慢病续方'
    },
    component: () => import('../pages/renewal/waiyuan')
  },
  /**
   * 提交申请
   * query
   * **** hasSubmitBtn 是否展示提交按钮 ‘yes’/‘no’
   * **** applyType 处方类型 ‘history’/‘waiyuan’
   */
  {
    path: '/renewal/submit',
    meta: {
      title: '慢病续方'
    },
    component: () => import('../pages/renewal/submit')
  },
  /**
   * 提交申请成功
   */
  {
    path: '/renewal/submit-succeed',
    meta: {
      title: '慢病续方'
    },
    component: () => import('../pages/renewal/submit-succeed')
  },
  /**
   * 续方列表
   */
  {
    path: '/renewal/list',
    meta: {
      title: '慢病续方'
    },
    component: () => import('../pages/renewal/list'),
    children: [
      {
        path: ':id',
        meta: {
          title: '慢病续方'
        },
        component: () => import('../../src/pages/renewal/list-state.vue')
      }
    ]
  },
  /**
   * 提交申请成功
   */
  {
    path: '/renewal/detail',
    meta: {
      title: '慢病续方'
    },
    component: () => import('../pages/renewal/detail')
  },
]



// WEBPACK FOOTER //
// ./src/router/renewal.js